import { render, staticRenderFns } from "./EventAdd.vue?vue&type=template&id=56abb5a0&scoped=true"
import script from "./EventAdd.vue?vue&type=script&lang=js"
export * from "./EventAdd.vue?vue&type=script&lang=js"
import style0 from "./EventAdd.vue?vue&type=style&index=0&id=56abb5a0&prod&scoped=true&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56abb5a0",
  null
  
)

export default component.exports